import React, { memo } from 'react';
import { Helmet } from 'react-helmet';

import { startingPriceLabel } from '../../../utils/pricing';

// Import Images
import slide1DesktopImport from '../../../images/slider/slide1.webp';
import slide1MobileImport from '../../../images/slider/mobile_optimized_slide1.webp';

const slide1Desktop = typeof slide1DesktopImport === 'object' ? slide1DesktopImport.default : slide1DesktopImport;
const slide1Mobile = typeof slide1MobileImport === 'object' ? slide1MobileImport.default : slide1MobileImport;

const carDesktopImgUrl = 'https://ridenrepair.com/images/car.webp';
const carMobileImgUrl = 'https://ridenrepair.com/images/car_mobile.webp';
const wheelImgUrl = 'https://www.ridenrepair.com/images/wheel.webp';

const SliderOne = memo(({ isMobileBrowser, cityKey = '', areaKey = '', cityContent, setCitiesModal, setOpenModal, heading = '' }) => {
  // Choose the appropriate image based on isMobileBrowser prop
  const backgroundImage = isMobileBrowser ? slide1Mobile : slide1Desktop;

  let locationText = '';

  if (cityKey) {
    // Capitalize the first letter of each word in cityKey
    const formattedCityKey = cityKey
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

    // Find matching area object in cityContent (if cityKey is valid)
    const areaObj = cityContent[cityKey]?.areas?.find(
      (area) => area.value === areaKey
    );
    // If found, we have a label for display
    const areaLabel = areaObj?.label || '';
    
    if (cityKey && areaLabel) {
      locationText = ` in ${areaLabel}, ${formattedCityKey}`;
    } else if (cityKey) {
      locationText = ` in ${formattedCityKey}`;
    }
  }

  const finalHeading =
      heading ||
      `Bike & Car Repair Services at your Doorstep${locationText}`;

  return (
    <>
      {typeof slide1Desktop === 'string' && (
        <Helmet>
          <link
            rel="preload"
            as="image"
            href={slide1Desktop}
            media="(min-width: 769px)"
          />
          <link
            rel="preload"
            as="image"
            href={slide1Mobile}
            media="(max-width: 768px)"
          />
        </Helmet>
      )}

      <section className="ttr-slider style-2 rr-hero" aria-label="Hero">
        <div className="slider-img slide-move">
          {/* Including an img tag for SEO and accessibility */}
          <img
            src={backgroundImage}
            alt="Bike and car repair services at your doorstep"
            className="visually-hidden"
            width={1920}
            height={970}
            loading="eager"
          />
        </div>
        <div className="slider-content container text-center text-white">
          <div className="content-inner">
            <h1>{finalHeading}</h1>
            <p className="rr-hero-subtitle">{`Book in 30 seconds. Mechanic at your doorstep in 30 minutes. From ${startingPriceLabel('site')}. 30-day warranty.`}</p>
            <div className="rr-hero-cta-row">
              {typeof setOpenModal === 'function' && (
                <button className="rr-hero-cta-primary" type="button" onClick={() => setOpenModal(true)}>
                  Book Now
                </button>
              )}
              <button className="rr-hero-cta" type="button" onClick={() => setCitiesModal(true)}>
                CITIES WE SERVE
              </button>
            </div>
            <div className="rr-hero-trust">
              <span><strong>2,00,000+</strong> Customers</span>
              <span aria-hidden="true">·</span>
              <span><strong>4.8★</strong> Rating</span>
              <span aria-hidden="true">·</span>
              <span><strong>32+</strong> Cities</span>
              <span aria-hidden="true">·</span>
              <span><strong>30-Day</strong> Warranty</span>
            </div>
            <div className="car-wheel">
              <picture>
                <source
                  media="(max-width: 1024px)"
                  srcSet={carMobileImgUrl}
                  type="image/webp"
                />
                <img
                  src={carDesktopImgUrl}
                  alt="Doorstep car and bike repair service"
                  width={1183}
                  height={432}
                  loading="eager"
                  fetchPriority="high"
                />
              </picture>
              <div className="wheel-1">
                <img
                  src={wheelImgUrl}
                  alt="Wheel"
                  width={198}
                  height={198}
                  loading="eager"
                  fetchPriority="high"
                />
              </div>
              <div className="wheel-2">
                <img
                  src={wheelImgUrl}
                  alt="Wheel"
                  width={198}
                  height={198}
                  loading="eager"
                  fetchPriority="high"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
});

export default SliderOne;
